module.exports = __webpack_public_path__ + "img/icon_scancode_btn.24cd001a.svg";